import Handlebars from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.9/js/handlebars";
import currentWidgetDetails from "utilities/platform/widget-details";





'use strict';





var helpers = {

  textarea: function(data) {
    var requiredAttrs = ["id"],
      reservedAttrs = ["type","data-mask","data-gis-mask"],
      combinableAttrs = {"class": "spa-input-textarea", "value": ""},
      validationRules = (data.validationRules),
      attrsStr,
      optionsString="",
      output;

    if(!Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).pass) {


        throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).missingField);


        if(window.console && console.log) {
          console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.textarea.attrs,requiredAttrs).missingField);
          return "";
        }
    }
    Handlebars.helpers.removeReservedAttrs(data.textarea.attrs,reservedAttrs);
    Handlebars.helpers.combineAttrs(data.textarea.attrs,combinableAttrs);
    attrsStr = Handlebars.helpers.buildAttrsString(data.textarea.attrs);

    output = '<div data-input-version="v2.0.0" class="spa-input spa-input-box spa-input--'+((data.skin) ? data.skin : 'material-design')+' '+((data.containerClasses) ? data.containerClasses.join(' ') : '')+'"> \
              <label class="spa-input-label" for="'+data.textarea.attrs.id+'">'+data.label.text+((data.required) ? '<span class="spa-input-label--required"> *</span>' : '')+'<span class="ada-hidden"> '+((data.label.adaText) ? data.label.adaText : '')+'</span></label> \
              <textarea '+attrsStr + ((validationRules) ? (' data-validation-rules=\'' + JSON.stringify(validationRules).replace(/'/g, "&#39;") + '\'') : '') +
              ((data.required) ? 'required' + ((typeof data.required === 'string') ? ' data-custom-required-message="' + data.required + '"' : '') : '' ) + '>' + ((data.textarea.attrs.value !== undefined) ? data.textarea.attrs.value : '')+'</textarea> \
              <p class="spa-input-hint">'+((data.hintText) ? data.hintText : '')+'</p> \
            </div> \
            <div id="' + data.textarea.attrs.id + '_errorMessage" class="spa-input-error-message spa-icon--error" aria-hidden="true"></div>';
    return new Handlebars.SafeString(output);
  }
};



module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};


module.exports.helpers = helpers;
